import React, { FC } from "react";
import classes from "./style/UI_ITOModuleSubTitle.module.css";
import { IUI_ITOModuleSubTitle } from "../../interfaces/Ui/IUI_ITOModuleSubTitle/IUI_ITOModuleSubTitle";

// подзаголовок
export const UI_ITOModuleSubTitle: FC<IUI_ITOModuleSubTitle> = ({
  title,
  className = "",
}) => {
  return <div className={`${classes.subtitle} ${className}`}>{title}</div>;
};
